class BraneySelect {
    constructor() {
        this.selects = document.querySelectorAll('select.braney-selopt');
        if (!this.selects.length) return;

        this.selects.forEach(select => {
            const custom = this.createCustomSelect(select);
            select.parentNode.classList.add("braney-selopt-wrapper");
            select.parentNode.insertBefore(custom, select);
            this.bindOptions(custom, select);

            select.addEventListener('change', () => {
                this.syncCustomFromSelect(custom, select);
            });

            // setTimeout(()=>{
            //     select.value = 6;
            //     select.dispatchEvent(new Event('change', { bubbles: true }));
            // }, 3000);
        });
    }

    createCustomSelect(select) {
        const wrapper = document.createElement('div');
        [...select.attributes].forEach(attr => {
            wrapper.setAttribute(attr.name, attr.value);
        });
        wrapper.className = 'custom-braney-selopt';

        // value hiển thị
        const active = document.createElement('div');
        const presentation = document.createElement('div');
        const activeText = document.createElement('p');
        active.className = 'select-value-active';
        activeText.innerHTML = `<div class="value-text"><p>${select.options[select.selectedIndex]?.text || ''}</p></div>`;
        
        presentation.className = 'presentation';
        presentation.innerHTML = `<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22.7998 0H1.00191C0.154348 0 -0.308904 0.988284 0.233298 1.63972L11.3981 15.0538C11.8041 15.5417 12.556 15.5327 12.9503 15.0353L23.5834 1.62119C24.103 0.965721 23.6362 0 22.7998 0Z" fill="#828282"/>
                                </svg>`;
        active.role = "button";
        active.appendChild(activeText);
        active.appendChild(presentation);

        // options
        const options = document.createElement('div');
        [...select.attributes].forEach(attr => {
            options.setAttribute(attr.name, attr.value);
        });

        options.className = 'braney-options';

        const optionsWrapper = document.createElement('div');
        optionsWrapper.className = 'braney-options-wrapper';

        [...select.options].forEach(opt => {
            const item = document.createElement('div');
            item.classList.add('option-item');

            [...opt.attributes].forEach(attr => {
                item.setAttribute(attr.name, attr.value);
            });

            // text
            item.textContent = opt.textContent;
            optionsWrapper.appendChild(item);

            if (opt.selected){
                item.setAttribute('selected', '');
            }else{
                item.removeAttribute('selected');
            }
        });
        
        options.appendChild(optionsWrapper);

        wrapper.appendChild(active);
        wrapper.appendChild(options);

        // toggle
        active.addEventListener('click', () => {
            if (!options.classList.contains('open')) {
                this.openOptions(active, options);
            } else {
                this.closeOptions(active, options);
            }
        });

        window.addEventListener('click', (e) => {
            if (!(e.target === wrapper || e.target.closest('.custom-braney-selopt') || e.target === options || e.target.closest('.braney-options'))){
                this.closeOptions(active, options);
            }
        })

        return wrapper;
    }

    bindOptions(custom, select) {
        const active = custom.querySelector('.select-value-active');
        const options = custom.querySelector('.braney-options');
        if (options && active){
            const items = options.querySelectorAll('.option-item');
            items.forEach((item)=>{
                item.addEventListener('click', e => {
                    const value = item.getAttribute('value');
                    const label = item.textContent;

                    // update UI
                    active.querySelector('.value-text').textContent = label;
                    active.setAttribute('value', value);
                    
                    items.forEach(i => {
                        i.toggleAttribute('selected', i === item);
                    });
                    this.closeOptions(active, options);
        
                    // update select
                    if (select.value !== value) {
                        select.value = value;
                        select.dispatchEvent(
                            new Event('change', { bubbles: true })
                        );
                    }
                });
            })
        }
    }

    syncCustomFromSelect(custom, select) {
        const active = custom.querySelector('.select-value-active');
        const items = custom.querySelectorAll('.option-item');

        const selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return;

        const value = selectedOption.value;
        const label = selectedOption.text;

        // update active UI
        active.querySelector('.value-text').textContent = label;
        active.setAttribute('value', value);

        // update selected state
        items.forEach(item => {
            item.toggleAttribute(
                'selected',
                item.getAttribute('value') === value
            );
        });
    }

    selected(custom, choice){
        const active = custom.querySelector('.select-value-active');
        const options = custom.querySelector('.braney-options');
        const select = custom.closest('.braney-selopt-wrapper')?.querySelector('.braney-selopt');

        if (options && active){
            const items = options.querySelectorAll('.option-item');
            items.forEach((item)=>{
                if (item.getAttribute('value') == choice){
                    const value = item.getAttribute('value');
                    const label = item.textContent;

                    // update UI
                    active.querySelector('.value-text').textContent = label;
                    active.setAttribute('value', value);

                    items.forEach(i => {
                        i.toggleAttribute('selected', i === item);
                    });
                    this.closeOptions(active, options);

                    // update select
                    
                    if (select.value !== value) {
                        select.value = value;
                        select.dispatchEvent(
                            new Event('change', { bubbles: true })
                        );
                    }
                }
            })
        }
    }

    positionOptions(trigger, dropdown) {
        const rect = trigger.getBoundingClientRect();

        dropdown.style.top =
            rect.bottom + window.scrollY + 4 + 'px';
        dropdown.style.left =
            rect.left + window.scrollX + 'px';
        dropdown.style.width = rect.width + 'px';
    }

    openOptions(trigger, dropdown) {
        document.body.appendChild(dropdown);
        trigger.classList.add('modal-showed');
        dropdown.classList.remove('hidden');
        dropdown.classList.add('open');

        this.positionOptions(trigger, dropdown);

        this.onScroll = () => {
            this.positionOptions(trigger, dropdown);
        };

        window.addEventListener('scroll', this.onScroll, true);
        window.addEventListener('resize', this.onScroll);
    }

    closeOptions(trigger, dropdown) {
        trigger.classList.remove('modal-showed');
        dropdown.classList.add('hidden');
        dropdown.classList.remove('open');

        window.removeEventListener('scroll', this.onScroll, true);
        window.removeEventListener('resize', this.onScroll);
    }
}

export default BraneySelect;
